import request from '@/config/request'

export default {
    registerMpUserInfo: function (params) {
        return request({
            url: '/common/userinfo/registermpemployeeuserinfo',
            method: 'post',
            params: params

        })
    },
}


// WEBPACK FOOTER //
// ./src/api/common/userinfo.js